/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanySimplesInfo = {
  properties: {
    startDate: {
      type: 'number',
    },
    endDate: {
      type: 'number',
    },
  },
} as const;
